import React, { useContext } from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import ReactPlayer from 'react-player/vimeo';
import { DrawerContext } from '../../controller/context/DrawerWidthContext';
import { useTheme } from '@emotion/react';

const drawerWidth = 300;
// Styling the Video Container for responsiveness
const VideoContainer = styled(Box)({
  position: 'relative',
  paddingTop: '56.25%', // 16:9 Aspect Ratio
  marginBottom: '20px',
  overflow: 'hidden',
  borderRadius: '8px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
});

// Styled ReactPlayer for responsiveness
const StyledReactPlayer = styled(ReactPlayer)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100% !important',
  height: '100% !important',
});

// Main content layout that adapts to the drawer state
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: open ? `${drawerWidth}px` : 0,
  })
);

const VideoPage = ({ videoUrl, title, date, description, documents }) => {
  const theme = useTheme();
  return (
    <Container maxWidth="lg" sx={{ py: 8, px: { xs: 2, sm: 3 },height:'98vh',  overflowY: 'auto',
  }}>
        
        {/* Video Embed */}
        <VideoContainer>
          <StyledReactPlayer url={videoUrl} controls />
        </VideoContainer>
        
        <CardContent>
          {/* Title */}
          <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 1 }}>
            {title}
          </Typography>
          
          {/* Date */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {new Date(date).toLocaleDateString(undefined, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </Typography>
          
          {/* Scrollable Description */}
          <Box
            sx={{
              borderRadius: 1,
              padding: 1,
           }}
          >
            <Typography
             color={theme.palette.text}
              sx={{ fontSize: { xs: '0.9rem', sm: '1rem', overflowY: 'scroll'} }}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Box>
          <Typography variant='button'><b>Documents:</b></Typography>
          {documents.map((i,index)=>{
            return <a key={index} href={i.url} target='_blank'><Typography fontWeight="bold">{i.title}</Typography></a>
          })}
        </CardContent>
  
    </Container>
  );
};

export default VideoPage;
